import { gsap } from "gsap";
import { PixiPlugin } from "gsap/PixiPlugin.js";
import { MotionPathPlugin } from "gsap/MotionPathPlugin.js";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(PixiPlugin, MotionPathPlugin);

// --- ORANGE PANEL ---


const tl = gsap.timeline({
  scrollTrigger: {
    trigger: ".home-banner",
    scrub: 2,
    // pin: true,
    
    start: "top 50%",
    end: "80%"
  }
})
.fromTo(".hchi-type-one ", 
        { 
          scale: 0.6, 
          y: 50 
        }, 
        { 
          scale: 1, 
          ease: "none", 
          y: 0
        }
       )


function desktopScrollTriggers() {
  // half content hlaf image type one image scroll effect
  gsap.to(".hchi-type-one-wrap-top-users", {
    xPercent: 100,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 3,
      start: "top 50%",
      end: "100%"
    }, 
  });
  gsap.to(".hchi-type-one-wrap-bottom-users", {
    xPercent: -50,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 3,
      start: "top 50%",
      end: "100%"
    }, 
  });
  gsap.to(".hchi-type-one-wrap-img", {
    yPercent: 0,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 3,
      start: "50%",
      end: "100%"
    }, 
  });
  
  
  // half content hlaf image type two image scroll effect
  gsap.to(".founder-img", {
    xPercent: -50,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-two",
      scrub: 3,
      start: "top 80%",
      end: "100%"
    }, 
  });
  gsap.to(".feature_img-wrap", {
    yPercent: 0,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-two",
      scrub: 3,
      start: "top 80%",
      end: "100%"
    }, 
  });
  
}
function mobileScrollTriggers() {
  // half content hlaf image type one image scroll effect
  gsap.to(".hchi-type-one-wrap-top-users", {
    xPercent: 30,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 1,
      start: "top 30%",
      end: "100%"
    }, 
  });
  gsap.to(".hchi-type-one-wrap-bottom-users", {
    xPercent: -30,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 1,
      start: "top 30%",
      end: "100%"
    }, 
  });
  gsap.to(".hchi-type-one-wrap-img", {
    yPercent: 0,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-one",
      scrub: 1,
      start: "30%",
      end: "100%"
    }, 
  });
  
  
  // half content hlaf image type two image scroll effect
  gsap.to(".founder-img", {
    xPercent: -30,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-two",
      scrub: 1,
      start: "top 30%",
      end: "100%"
    }, 
  });
  gsap.to(".feature_img-wrap", {
    yPercent: 0,
    ease: "none",
    scrollTrigger: {
      trigger: ".hchi-type-two",
      scrub: 1,
      start: "top 30%",
      end: "100%"
    }, 
  });
  
}
ScrollTrigger.matchMedia({
  '(min-width:992px)':function(){
    desktopScrollTriggers();
  },
  '(max-width:991px)':function(){
    mobileScrollTriggers();
    
  }
})
  
